import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { PACK_IMAGE, BRAND, CHECKOUT_URL, PRODUCT, trustBadges } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-night" data-id="element-105" data-mp="4mi297ij3icw">
      <div className="mx-auto flex max-w-page flex-col items-center px-4 sm:px-6 lg:px-8 pt-5 pb-10 text-center" data-id="element-106" data-mp="4na0kq3ifu6v">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="text-[0.7rem] font-bold uppercase tracking-[0.34em] text-gold-bright" data-id="element-107" data-mp="127eeddqu7pdg">
          {BRAND}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 max-w-4xl font-display text-[1.75rem] sm:text-4xl lg:text-5xl font-bold uppercase leading-[1.1] text-gold-light" data-id="element-108" data-mp="nbydopvr4v83">
          {PRODUCT}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mt-2 max-w-3xl font-sans text-sm sm:text-base lg:text-lg font-semibold uppercase tracking-[0.08em] text-white" data-id="element-109" data-mp="3o7vl7nivvtyv">
          Comprendé mejor la Biblia y aprendé a llevar sus enseñanzas a tu vida
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.12
      }} src={PACK_IMAGE} alt={`${PRODUCT}: 6 módulos digitales y 5 bonos de estudio bíblico`} className="mt-3 max-h-[32vh] w-auto max-w-full object-contain sm:max-h-[36vh] lg:max-h-[38vh]" data-id="element-110" data-mp="359syjfdt6948" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-3 flex w-full flex-col items-center" data-id="element-111" data-mp="2ljpe15ynz8qm">
          <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-112" data-mp="n9i3xcn8leu4">
            Quiero comprender mejor la Biblia
          </CtaButton>
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/80" data-id="element-113" data-mp="ddnhs7jt11ml">
            {trustBadges.map(badge => <li key={badge} className="flex items-center gap-1.5" data-id="element-114" data-mp="1ayjilhmnxm7u">
                <CheckIcon size={13} className="flex-shrink-0 text-gold-bright" strokeWidth={3} data-id="element-115" data-mp="162capjapi0n9" />
                {badge}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed text-white/80" data-id="element-116" data-mp="3ltgm7o0v2mna">
          Una biblioteca digital simple y organizada para ayudarte a leer,
          comprender, reflexionar y aplicar las Escrituras en aproximadamente 15
          minutos al día,{' '}
          <span className="font-semibold text-gold-light" data-id="element-117" data-mp="21awco6qesnfd">
            incluso si hoy no sabés por dónde empezar.
          </span>
        </p>
      </div>
    </header>;
}